/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';

/**
 * 
 * @export
 * @interface GetBrokerBranchesResponseDto
 */
export interface GetBrokerBranchesResponseDto {
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof GetBrokerBranchesResponseDto
     */
    branches: Array<ReferentialDto>;
}

/**
 * Check if a given object implements the GetBrokerBranchesResponseDto interface.
 */
export function instanceOfGetBrokerBranchesResponseDto(value: object): value is GetBrokerBranchesResponseDto {
    if (!('branches' in value) || value['branches'] === undefined) return false;
    return true;
}

export function GetBrokerBranchesResponseDtoFromJSON(json: any): GetBrokerBranchesResponseDto {
    return GetBrokerBranchesResponseDtoFromJSONTyped(json, false);
}

export function GetBrokerBranchesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrokerBranchesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'branches': ((json['branches'] as Array<any>).map(ReferentialDtoFromJSON)),
    };
}

export function GetBrokerBranchesResponseDtoToJSON(json: any): GetBrokerBranchesResponseDto {
    return GetBrokerBranchesResponseDtoToJSONTyped(json, false);
}

export function GetBrokerBranchesResponseDtoToJSONTyped(value?: GetBrokerBranchesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branches': ((value['branches'] as Array<any>).map(ReferentialDtoToJSON)),
    };
}

